import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FE_LOBBY_BANNERS } from '../../utils/featureFlags/constants';
import { PAGE_SIZE } from '../../screens/Home/utils/processGames';
export var generateGameListData = function generateGameListData(pagedGames, pageNumber, ftueStep) {
  var scrollItemIndex = 0;
  var totalGamesCount = 0;
  var topRow = [];
  var bottomRow = [];
  pagedGames.forEach(function (gamePage, pageIndex) {
    totalGamesCount += gamePage.length;
    gamePage.forEach(function (game, index) {
      game = _objectSpread({}, game);
      var targetRow = gamePage.length === PAGE_SIZE ? index < PAGE_SIZE / 2 ? topRow : bottomRow : index % 2 === 0 ? topRow : bottomRow;
      targetRow.push(game);
      if (pageIndex === pageNumber) {
        scrollItemIndex = ftueStep !== null ? 0 : topRow.length - 5;
      }
    });
  });
  var gameList = topRow.map(function (item, index) {
    return [item, bottomRow[index]];
  });
  return {
    gameList: gameList,
    scrollItemIndex: scrollItemIndex,
    totalGamesCount: totalGamesCount
  };
};
export var checkIfBannersEnabled = function checkIfBannersEnabled(bannersExist) {
  var _getFeatureConfig;
  var _useFeatureFlags = useFeatureFlags(),
    getFeatureConfig = _useFeatureFlags.getFeatureConfig;
  var bannerEnabled = (_getFeatureConfig = getFeatureConfig(FE_LOBBY_BANNERS)) === null || _getFeatureConfig === void 0 ? void 0 : _getFeatureConfig.enabled;
  return bannerEnabled && bannersExist;
};